import { Protected } from './Protected'
import { PermissionString } from './types'

export const ProtectedComponent = ({
  permission,
  needsEveryPermission = false,
  children
}: {
  permission: PermissionString | PermissionString[]
  needsEveryPermission?: boolean
  children: React.ReactNode
}) => {
  return (
    <Protected
      permission={permission}
      needsEveryPermission={needsEveryPermission}
    >
      {isAllowed => isAllowed && children}
    </Protected>
  )
}
